// Матрица прав на фронте — зеркало backend (apps/permissions.py).
// Для скрытия недоступных кнопок. Реальная защита — на backend.
import type { RoleCode } from '@/types';

type ResourcePerms = Record<string, Set<string> | '*'>;

const ROLE_PERMISSIONS: Record<RoleCode, ResourcePerms> = {
  primary_admin: { '*': '*' },
  co_admin: {
    contracts: '*', counterparties: '*', objects: '*', estimates: '*',
    acts: '*', projects: '*', library: '*',
    members: new Set(['view', 'add', 'change']), invites: '*',
    integrations: '*', ai: new Set(['view', 'change']),
    security: new Set(['view']), notifications: '*',
  },
  gip: {
    projects: '*', estimates: new Set(['view', 'add', 'change']),
    contracts: new Set(['view']), objects: new Set(['view', 'change']),
    acts: new Set(['view', 'add', 'change']), library: '*',
    notifications: new Set(['view']),
  },
  engineer: {
    objects: new Set(['view', 'change']), acts: new Set(['view', 'add', 'change']),
    projects: new Set(['view']), contracts: new Set(['view']),
    library: new Set(['view', 'add']), notifications: new Set(['view']),
  },
  estimator: {
    estimates: '*', contracts: new Set(['view']), objects: new Set(['view']),
    library: new Set(['view', 'add']), notifications: new Set(['view']),
  },
  lawyer: {
    contracts: '*', counterparties: '*',
    library: new Set(['view', 'add']), notifications: new Set(['view']),
  },
  accountant: {
    acts: '*', contracts: new Set(['view']), estimates: new Set(['view']),
    integrations: new Set(['view']), notifications: new Set(['view']),
  },
  foreman: {
    objects: new Set(['view']), acts: new Set(['view', 'add']),
    projects: new Set(['view']), notifications: new Set(['view']),
  },
  viewer: {
    contracts: new Set(['view']), objects: new Set(['view']),
    estimates: new Set(['view']), acts: new Set(['view']),
    projects: new Set(['view']), library: new Set(['view']),
  },
  subcontractor: {
    projects: new Set(['view']), acts: new Set(['view', 'add']),
    estimates: new Set(['view']),
  },
};

export function roleCan(role: RoleCode, resource: string, action: string): boolean {
  const perms = ROLE_PERMISSIONS[role];
  if (!perms) return false;
  if (perms['*'] === '*') return true;
  const rp = perms[resource];
  if (rp === '*') return true;
  if (rp instanceof Set) return rp.has(action);
  return false;
}

export const ROLE_LABELS: Record<RoleCode, string> = {
  primary_admin: '★ Главный администратор',
  co_admin: '+ Со-администратор',
  gip: 'ГИП',
  engineer: 'Инженер',
  estimator: 'Сметчик',
  lawyer: 'Юрист',
  accountant: 'Бухгалтер',
  foreman: 'Прораб',
  viewer: 'Просмотр',
  subcontractor: 'Субподрядчик',
};
